/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Ai_Translate_SectionInputs */

const cs_blog_ai_translate_section = /** @type {(inputs: Blog_Ai_Translate_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přeložit do dalších jazyků`)
};

const en_blog_ai_translate_section = /** @type {(inputs: Blog_Ai_Translate_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translate to other languages`)
};

/**
* | output |
* | --- |
* | "Translate to other languages" |
*
* @param {Blog_Ai_Translate_SectionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_translate_section = /** @type {((inputs?: Blog_Ai_Translate_SectionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Translate_SectionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_translate_section(inputs)
	return cs_blog_ai_translate_section(inputs)
});